import React from 'react';
import { MapPinIcon, ExternalLinkIcon } from 'lucide-react';
import { Language, translations } from '../utils/translations';
export function LocationMap({
  lang
}: {
  lang: Language;
}) {
  const t = translations[lang];
  return <section className="rounded-[22px] border border-zinc-800 bg-zinc-900 p-5 shadow-lg" data-id="element-142" data-mp="16zjiqly7on3c">
      <h2 className="mb-5 text-center text-[19px] font-bold tracking-[-0.03em] text-zinc-50" data-id="element-143" data-mp="1b0v4uhhvmq6s">
        {t.mapTitle}
      </h2>
      
      <div className="overflow-hidden rounded-xl border border-zinc-800 bg-zinc-800" data-id="element-144" data-mp="1yrha610hxwd3">
        <iframe key="google-map-iframe" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2540.476569106093!2d30.51865517688225!3d50.45084939331006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4ce50f8b6e3c3%3A0xb528dc4d6bfc0ea6!2sKhreshchatyk%20St%2C%20Kyiv%2C%20Ukraine%2C%2002000!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus" width="100%" height="200" style={{
        border: 0,
        pointerEvents: 'auto',
        touchAction: 'pan-y'
      }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Maps Location" data-id="element-145" data-mp="23npkn13r11dx"></iframe>
      </div>
      
      <a href="https://maps.google.com/?q=Khreshchatyk+St,+Kyiv,+Ukraine" target="_blank" rel="noopener noreferrer" className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl bg-zinc-800 px-4 py-3.5 text-[14px] font-bold text-zinc-100 transition-colors hover:bg-zinc-700" data-id="element-146" data-mp="2bngzh1hysqun">
        <ExternalLinkIcon className="h-4 w-4 text-gold-500" data-id="element-147" data-mp="2go4r9pe0pbpx" />
        {t.mapOpen}
      </a>
    </section>;
}